const features = [
  {
    type: 'dark',
    icon: 'ri-shield-flash-line',
    title: '极致速度',
    subtitle: '7×24小时实时监控全网爆料平台，重磅猛料从发现到上架最快仅需30分钟',
    desc: '不让你错过任何一个大瓜',
  },
  {
    type: 'image',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20computer%20screens%20showing%20news%20monitoring%20dashboards%20in%20dark%20room%2C%20coral%20orange%20alert%20indicators%2C%20real%20time%20data%20tracking%2C%20professional%20monitoring%20center%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20modern%20tech%20aesthetic&width=800&height=500&seq=features-02&orientation=landscape',
    label: '全网监控',
    title: '全平台覆盖',
    desc: '实时同步911爆料网、51爆料网、91爆料网等主流平台',
  },
  {
    type: 'accent',
    number: '3',
    label: '重验证',
    title: '多源交叉验证',
    subtitle: '每条内容至少经过两个独立信源核实，确保信息真实可靠',
    desc: '宁缺毋滥，只做靠谱的爆料',
  },
  {
    type: 'icon',
    icon: 'ri-lock-2-line',
    title: '匿名保护',
    subtitle: '端到端加密投稿通道，不留存任何可追溯个人身份的日志信息',
    desc: '你的安全，我们放在第一位',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12">
          <p className="text-foreground-400 text-xs md:text-sm font-medium tracking-widest uppercase mb-2">Why Us</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-black text-foreground-950">
            为什么选择爆料网
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item, i) => {
            if (item.type === 'dark') {
              return (
                <div key={i} className="rounded-2xl md:rounded-3xl bg-foreground-950 p-5 md:p-6 flex flex-col justify-between min-h-[240px] md:min-h-[280px]">
                  <div>
                    <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-foreground-800 flex items-center justify-center mb-4">
                      <i className={`${item.icon} text-background-200 text-lg md:text-xl w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <h3 className="text-background-100 font-bold text-base md:text-lg mb-2">{item.title}</h3>
                    <p className="text-background-300/70 text-sm leading-relaxed">{item.subtitle}</p>
                  </div>
                  <p className="text-background-400 text-xs mt-4">{item.desc}</p>
                </div>
              );
            }

            if (item.type === 'image') {
              return (
                <div key={i} className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-200 relative min-h-[240px] md:min-h-[280px] group">
                  <img
                    src={item.image!}
                    alt={item.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-black/50 backdrop-blur-sm text-white text-xs font-semibold rounded-full">
                      {item.label}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <h3 className="text-white font-bold text-base md:text-lg mb-1">{item.title}</h3>
                    <p className="text-white/70 text-xs md:text-sm">{item.desc}</p>
                  </div>
                </div>
              );
            }

            if (item.type === 'accent') {
              return (
                <div key={i} className="rounded-2xl md:rounded-3xl bg-background-50 border border-background-200/70 p-5 md:p-6 flex flex-col justify-between min-h-[240px] md:min-h-[280px]">
                  <div>
                    <span className="block text-5xl md:text-6xl font-black text-accent-500 font-label leading-none mb-3">
                      {item.number}
                    </span>
                    <span className="text-foreground-400 text-xs font-medium tracking-wider uppercase">{item.label}</span>
                    <h3 className="text-foreground-900 font-bold text-base md:text-lg mt-3 mb-2">{item.title}</h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">{item.subtitle}</p>
                  </div>
                  <p className="text-foreground-400 text-xs mt-4">{item.desc}</p>
                </div>
              );
            }

            return (
              <div key={i} className="rounded-2xl md:rounded-3xl bg-background-50 border border-background-200/70 p-5 md:p-6 flex flex-col justify-between min-h-[240px] md:min-h-[280px]">
                <div>
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-foreground-900 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-background-100 text-lg md:text-xl w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-foreground-900 font-bold text-base md:text-lg mb-2">{item.title}</h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">{item.subtitle}</p>
                </div>
                <p className="text-foreground-400 text-xs mt-4">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}